// Pick one of a few options (time range, speaking time, theme).
import { cx } from '@/lib/cx';

type Option<T extends string> = { value: T; label: string };

type SegmentedProps<T extends string> = {
  label: string;
  options: readonly Option<T>[];
  value: T;
  onChange: (value: T) => void;
  /** Stretch to the full width with equal parts. */
  full?: boolean;
};

export function Segmented<T extends string>({ label, options, value, onChange, full }: SegmentedProps<T>) {
  return (
    <div className={cx('seg', full && 'full')} role="radiogroup" aria-label={label}>
      {options.map((o) => (
        // biome-ignore lint/a11y/useSemanticElements: a styled radio group; each button reports its checked state.
        <button
          key={o.value}
          type="button"
          role="radio"
          aria-checked={o.value === value}
          onClick={() => onChange(o.value)}
        >
          {o.label}
        </button>
      ))}
    </div>
  );
}
